module.exports = __webpack_public_path__ + "static/media/Connexion.f79a1a27.png";